<template>
  <b-tabs content-class="mt-0 " nav-class=" color_606D6D font-weight-bold" style="width: 100%;"
          active-nav-item-class="background_E9F5EA_page_7 tab-link__active"
          nav-item-class="color_606D6D"
          active-tab-class=" " justified>
    <b-tab title="Задачи">
      <b-container fluid>

        <b-row><b-col cols="12">Доступные задачи</b-col></b-row>
        <b-row >
          <b-col cols="3" v-for="(item, index) in aiPromts" :key="item.aiPromtId" >
            <b-card :title="item.aiPromtName" class="w-100 h-100" @click="" :class="currentPromt.aiPromtId === item.aiPromtId ? 'selected-card' : ''">

              <b-card-text >
                {{item.aiPromtComment}}
              </b-card-text>
              <button class="save_btn_common" @click="selectPromt(item)">Выбрать</button>
            </b-card>
          </b-col>

        </b-row>
        <b-row>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'patientInfo')">
            <b-form-group id="patientInfo" label-for="patientInfo" label="Информация о пациенте">
              <b-textarea id="patientInfo" class="" v-model="promt.patientInfo" rows="5"></b-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'complaints')">
            <b-form-group id="complaints" label-for="complaintsText" label="Жалобы (каждая с новой строки)">
              <b-textarea id="complaintsText" class="" v-model="groupsSelect" rows="5"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'analytes')">
            <label class="d-block">Аналиты (выберите из списка)</label>
          </b-col>
          <b-col cols="3" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'analytes')">
            <label class="d-block">Выбранные аналиты</label>
          </b-col>
          <b-col cols="3" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'analytes')">
            <label class="d-block"><b-link @click="clearAllSelectedAnalits"><b-icon icon="x-circle"></b-icon> Очистить всё</b-link></label>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'analytes')">
<!--            <b-container>-->
<!--              <b-row>Аналиты (выберите из списка)</b-row>-->
<!--              <b-row><input type="text"></b-row>-->
<!--              <b-row style="min-height: 20rem; height:100%;">-->

<!--              </b-row>-->
<!--            </b-container>-->


              <b-form-select v-model="promt.analytes"
                             :options="reportParams"
                             multiple :select-size="10" class="h-100"></b-form-select>

          </b-col>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'analytes')">
            <h5>
            <span class="" v-for="(item, index) in promt.analytes" :key="index">

                <b-badge variant="success" size="xl" style="white-space: normal!important; text-align: left!important;" class="m-1">{{ item }}&nbsp;<b-icon style="cursor: pointer;" size="md" icon="x-circle" aria-hidden="true" @click="deleteFromSelected(index)" title="Удалить"></b-icon>
                </b-badge>

            </span>
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'physicalExamination')">
            <b-form-group id="physicalExam" label-for="physicalExam" label="Физикальный осмотр пациента">
              <b-textarea id="physicalExam" class="" v-model="physicalExam" rows="5"></b-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'suspectedDiagnoses')">
            <b-form-group id="suspectedDiagnoses" label-for="suspectedDiagnoses" label="Предполагаемые диагнозы (каждый с новой строки)">
              <b-textarea id="suspectedDiagnoses" class="" v-model="suspectedDiagnoses" rows="5"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-if="inputFields.find((el) => el.aiInputFieldNameInPrompt === 'additionalInfo')">
            <b-form-group id="patientInfo" label-for="patientInfo" label="Дополнительная информация">
              <b-textarea id="patientInfo" class="" v-model="promt.additionalInfo" rows="5"></b-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="aiModel" label-for="aiModel" label="Выберите модель для выполнения задачи">
              <b-form-select id="aiModel" v-model="promt.model" :options="aiModels" :select-size="1"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6"></b-col>
        </b-row>
        <div class="row mx-0">
          <button class="save_btn_common" :disabled="btnGenerateAiReportDisabled" @click="generateAiReport">Сформировать отчёт</button>

        </div>
        <b-card v-if="aiResult" class="w-100" title="Заключение ИИ">
          <b-card-text>
            <div v-html="aiResult"></div>
          </b-card-text>
        </b-card>

      </b-container>

    </b-tab>
    <b-tab title="История задач" lazy>
      <PatientAiReportExecutionList v-bind:patient-id="patientId">
      </PatientAiReportExecutionList>
    </b-tab>
  </b-tabs>
</template>

<script>
import {host} from "@/constants";
import markdownit from 'markdown-it'
import PatientAiReportExecutionList from "@/components/patients/ai/PatientAiReportExecutionList.vue";


export default {
  components: {PatientAiReportExecutionList},
  props: ["patientId"],
  name: "PatientAiReports",
  data() {
    return {
      searchString: '',
      btnGenerateAiReportDisabled: false,
      aiResult: '',
      aiPromts: [],
      reportParams: [],
      searchedParams: [],
      selectedParams:[],
      groupsSelect: '',
      suspectedDiagnoses: '',
      physicalExam: '',
      patient:{},
      aiModels: [
        {value: 'groq', text: 'Remote.gpt-oss-120b'},
        {value: 'gpt-oss:120b', text: 'Каллисто.gpt-oss-120b'},
        {value: 'llama3.3:70b', text: 'llama3.3:70b'},
        {value: 'meditron:7b', text: 'meditron:7b'},
        {value: 'meditron:70b', text: 'meditron:70b'},
      ],
      currentPromt: {
        aiPromtId: -1,
        aiPromtName: '',
        aiPromtComment: '',
        aiPromt: ''
      },
      promt: {
        aiPromtId: 0,
        model:"gpt-oss:120b",
        complaints:[""],
        suspectedDiagnoses:[""],
        analytes:[],
        patientInfo:"",
        physicalExamination: [""],
        additionalInfo:""
      },
      inputFields: []
    }
  },
  watch: {
    // whenever question changes, this function will run
    searchString: function (newQuestion, oldQuestion) {
      if(newQuestion)
        this.searchedParams = this.reportParams.filter(el => (el.value.toLowerCase().includes(newQuestion.toLowerCase())))
      else
        this.searchedParams = [].concat(this.reportParams)
    },

  },
  methods: {
    clearAllSelectedAnalits() {
      this.promt.analytes = []
    },
    deleteFromSelected(index) {
      this.promt.analytes.splice(index, 1)
    },
    async fetchData() {
      fetch(host + '/rest/ai-reports', {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {

            console.log(json.aiPromts)
            this.aiPromts = json.aiPromts


            //console.log(JSON.stringify(json))
          }).catch(error => {
            console.log(error)
            this.loading = false
          })

      fetch(host + '/rest/patients/' + this.patientId, {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {
            this.patient = json.patient
            this.promt.patientInfo = this.patient.gender + ' пол, ' + this.patient.ageText
            console.log(json)
            this.loading = false
          })

      fetch(host + '/rest/params/clientreport/' + this.patientId + '', {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {

            this.reportParams = json.reportParams.reduce((acc, current) => {
              const x = acc.find(item => item.paramId === current.paramId)
              if (!x) {
                return acc.concat([current])
              } else {
                return acc
              }
            }, []).map(item => {
              return {
                  value: item.paramName + (item.biomaterialTypeName ? ', ' + item.biomaterialTypeName : '') + ' ' + (item.paramType === 2 || (item.paramType === 7 && item.propertyName) ? item.propertyName + ', ' + item.propertyValueName : item.paramValue + item.measurementUnitName),
                  text: item.paramName + (item.biomaterialTypeName ? ', ' + item.biomaterialTypeName : '') + ' ' + (item.paramType === 2 || (item.paramType === 7 && item.propertyName) ? item.propertyName + ', ' + item.propertyValueName : item.paramValue + item.measurementUnitName)
                }
              })
            this.searchedParams = this.searchedParams.concat(this.reportParams)

          }).catch(error => {
            console.log(error)
            this.loading = false
          })

      this.groupsSelect = ''
      let response = await fetch(host + '/rest/patients/' + this.patientId + '/dynamic/checklistbygroup/6', {
        credentials: "include"
      })
      let json  = await response.json()
      for (let el of json.options) {
        if (el.selected) {
          if (this.groupsSelect == '')
            this.groupsSelect = el.text
          else
            this.groupsSelect = this.groupsSelect.concat('\n', el.text)

        }
      }

      response = await fetch(host + '/rest/patients/' + this.patientId + '/dynamic/checklistbygroup/8', {
        credentials: "include"
      })
      json  = await response.json()
      for (let el of json.options) {
        if (el.selected && !this.groupsSelect.includes(el.text)) {
          if (this.groupsSelect == '')
            this.groupsSelect = el.text
          else
            this.groupsSelect = this.groupsSelect.concat('\n', el.text)
        }
      }

      response = await fetch(host + '/rest/patients/' + this.patientId + '/dynamic/checklistbygroup/9', {
        credentials: "include"
      })
      json  = await response.json()
      for (let el of json.options) {
        if (el.selected  && !this.groupsSelect.includes(el.text) ) {
          if (this.groupsSelect == '')
            this.groupsSelect = el.text
          else
            this.groupsSelect = this.groupsSelect.concat('\n', el.text)
        }
      }


      response = await fetch(host + '/rest/patients/' + this.patientId + '/dynamic/checklistbygroup/10', {
        credentials: "include"
      })
      json  = await response.json()
      for (let el of json.options) {
        if (el.selected  && !this.groupsSelect.includes(el.text)) {
          if (this.groupsSelect == '')
            this.groupsSelect = el.text
          else
            this.groupsSelect = this.groupsSelect.concat('\n', el.text)
        }
      }

    },
    selectPromt(item) {
      this.currentPromt = item
      this.loading = true
      fetch(host + '/rest/ai-reports/' + item.aiPromtId + '/input-fields', {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {
            this.inputFields = json.aiInputFields
            this.loading = false

            console.log("InputFields=" + JSON.stringify(json))
          }).catch(error => {
            console.log(error)
            this.loading = false
          })

      // Получение Значений атрибутов
      fetch(host + '/rest/ai-reports/' + item.aiPromtId + '/clients/' + this.patientId + '/input-fields-values', {
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {
            //this.inputFields = json.aiInputFields
            this.loading = false
            for (let val of json.aiInputFieldsValues) {
              switch (val.aiInputFieldId) {
                case 2: this.promt.patientInfo = val.aiInputFieldValue; break;
                case 4: this.groupsSelect = val.aiInputFieldValue; break;
                case 6: this.physicalExam = val.aiInputFieldValue; break;
                case 7: this.promt.analytes = JSON.parse(val.aiInputFieldValue); break;
                case 8: this.suspectedDiagnoses = val.aiInputFieldValue; break;
                case 9: this.promt.additionalInfo = val.aiInputFieldValue; break;
              }
            }

            console.log("InputFieldsValues = " + JSON.stringify(json))
          }).catch(error => {
            console.log(error)
            this.loading = false
          })
    },
    generateAiReport() {
      console.log('generateAiReport Call')
      if (this.currentPromt.aiPromtId === -1) {
        this.$errorToast('Необходимо выбрать промт')
        return
      }
      this.promt.aiPromtId = this.currentPromt.aiPromtId
      this.promt.complaints = this.groupsSelect.split('\n')
      this.promt.suspectedDiagnoses = this.suspectedDiagnoses.split('\n')
      this.promt.physicalExamination = this.physicalExam.split('\n')
      console.log(JSON.stringify(this.promt))
      /*
      {value: 'llama3.3:70b', text: 'llama3.3:70b'},
        {value: 'meditron:7b', text: 'meditron:7b'},
        {value: 'groq', text: 'groq - openai'},
        {value: 'meditron:70b', text: 'meditron:70b'}, */
      let aiAddress = host + '/rest/ai-reports/report-generation'
      // if (this.promt.model === 'groq') {
      //   aiAddress = 'https://ai-test.ronix.ru/report-generation'
      // }

      let toastId = 'AiReport_' + new Date().getTime()
      this.$reportCreationToast(toastId, 'Получаем заключение')
      this.btnGenerateAiReportDisabled = true

      //console.log('Before Ai Call')

      let startExecRq =  {
        clientId: this.patientId,
        aiPromtId: this.currentPromt.aiPromtId,
        modelName: this.promt.model,
        aiPromt: JSON.stringify(this.promt)
      }

      let aiPromptExecutionId = -1;

      fetch(host + '/rest/ai-reports/ai-promt-execs/start', {
        method: 'POST',
        body: JSON.stringify(startExecRq),
        headers: {'Content-Type': 'application/json; charset=utf-8'},
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {
            aiPromptExecutionId = json.entityId

            fetch(aiAddress, {
              method: 'POST',
              body: JSON.stringify(this.promt),
              credentials: "include",
              headers: {'Content-Type': 'application/json; charset=utf-8'}
            })
                .then(response => response.json())
                .then(json => {
                  let errorText = null
                  if (json.resultCode === 0) {
                    const md = markdownit()
                    //const result =
                    this.aiResult = md.render(json.responseText);

                  } else {
                    this.$errorToast('Ошибка вызова ИИ-агента')
                    this.aiResult = null
                    errorText = 'Ошибка вызова ИИ-агента'
                  }

                  this.$reportCreationHideToast(toastId)
                  this.btnGenerateAiReportDisabled = false

                  this.finishExecRequest(aiPromptExecutionId, 1, this.aiResult, errorText)



                  //console.log(JSON.stringify(json))
                }).catch(error => {
              this.$reportCreationHideToast(toastId)
              this.$errorToast('Ошибка вызова ИИ-агента')
              console.log(error)
              this.finishExecRequest(aiPromptExecutionId, 2, null, error)
            })





          }).catch(error => {
        this.$reportCreationHideToast(toastId)
        this.$errorToast('Ошибка вызова ИИ-агента')
        console.log(error)
      })



      this.sendData()
    },

    finishExecRequest(aiPromptExecutionId, executionStatus, responseText, errorMessage) {
      let finishExecRq = {
        aiPromptExecutionId: aiPromptExecutionId,
        executionStatus: executionStatus,
        responseText: responseText,
        errorMessage: errorMessage
      }

      fetch(host + '/rest/ai-reports/ai-promt-execs/finish', {
        method: 'POST',
        body: JSON.stringify(finishExecRq),
        headers: {'Content-Type': 'application/json; charset=utf-8'},
        credentials: "include"
      })
          .then(response => response.json())
          .then(json => {
            this.$reportCreationHideToast(toastId)
          }).catch(error => {
        this.$reportCreationHideToast(toastId)
        this.$errorToast('Ошибка вызова ИИ-агента')
        console.log(error)
      })
    },


    sendData() {
      const url = host + '/rest/ai-reports/input-fields-values';


      const rq = {
        clientId: this.patientId,
        aiPromtId: this.currentPromt.aiPromtId,
        values: []
      }
      for (let infld of this.inputFields) {
        let val = null
        switch (infld.aiInputFieldId) {
          case 2: val = this.promt.patientInfo; break;
          case 4: val = this.groupsSelect; break;
          case 6: val = this.physicalExam; break;
          case 7: val = JSON.stringify(this.promt.analytes); break;
          case 8: val = this.suspectedDiagnoses; break;
          case 9: val = this.promt.additionalInfo; break;
        }
        if (val)
          rq.values.push({aiInputFieldId: infld.aiInputFieldId, aiInputFieldValue: val })
      }
      //const data = ;

      fetch(url, {
        method: 'PUT',
        credentials: "include",
        body: JSON.stringify(rq),
        headers: {'Content-Type': 'application/json; charset=utf-8'},
        keepalive: true
      })
          .then(response => response.json())
          .then(json => {


            console.log(JSON.stringify(json))
          }).catch(error => {
        this.$reportCreationHideToast(toastId)
        console.log(error)
      })
      // Безопасная отправка данных в фоновом режиме браузера
      //navigator.sendBeacon(url, data);
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.sendData();
      }
    },
    handleBeforeUnload() {
      this.sendData();
    }
  },
  async mounted() {
    window.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    await this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.sendData();
  }
}
</script>

<style scoped>

.selected-card {
  background-color: #8fd19e;
}

.badgeSelected {
  font-size: medium!important;
  padding: 0.2rem;
}

</style>